var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-container" }, [
    _c("div", { staticClass: "dashboard-header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "header-lower" }, [
        _c(
          "span",
          [
            _c("router-link", { attrs: { to: "/dashboard" } }, [
              _vm._v("My Team")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "far fa-chevron-double-right" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.event.name))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-nav" }, [
        _c(
          "div",
          { class: _vm.currentRoute === "home" ? "selected" : null },
          [_c("router-link", { attrs: { to: "home" } }, [_vm._v("Home")])],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.currentRoute === "details" ? "selected" : null },
          [
            _c("router-link", { attrs: { to: "details" } }, [_vm._v("Details")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.currentRoute === "sessions" ? "selected" : null },
          [
            _c("router-link", { attrs: { to: "sessions" } }, [
              _vm._v("Sessions")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.currentRoute === "attendees" ? "selected" : null },
          [
            _c("router-link", { attrs: { to: "attendees" } }, [
              _vm._v("Attendees")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [_vm._v("Settings")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [_c("router-view")], 1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-upper" }, [
      _c("h2", [_vm._v("COMPENDIUM")]),
      _vm._v(" "),
      _c("div", { staticClass: "profile-btn" }, [
        _c("i", { staticClass: "fas fa-user-circle" }),
        _vm._v(" "),
        _c("i", { staticClass: "fas fa-chevron-down" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-467a34bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-467a34bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/index.vue
// module id = wDjA
// module chunks = 1